<template>
    <div id="trunk">
        <lead :headOption="headOption"/>
        <main class="main">
            <router-view />
        </main>
        <!-- <foote/> -->
    </div>
</template>
<script>
import lead from "@/components/common/head";
import foote from "@/components/common/footer";
export default {
    data() {
        return {
        // 顶部模块标题：
            headOption: {
                link: "/inspection",
                title: "校园直播"
            },
        };
    },
    created() { },
    mounted(){},
    methods: {},
    components: {
        lead,
        foote
    }
};
</script>
<style lang="scss">
.main {
    min-height: calc(100vh - 80px);
    // padding: 25px 0 40px;
}
.course-menunav a {
    display: block;
    line-height: 65px;
}
    //  @import  './../../../assets/css/terch.css'
</style>